module.exports = __webpack_public_path__ + "static/media/satsure-logo-new.f2f60221.svg";